import { useTheme } from "@mui/material/styles";
import classnames from "classnames";
import PropTypes from "prop-types";
import { default as React } from "react";
import Select from "react-select";
import "./styles.css";
import {merge} from "lodash";

const customsStyles = (globalTheme, additionalStyles = {}) => ({
    ...additionalStyles,
    menu: (provided) => {
        const result = {
            ...provided,
            zIndex: 2,
        };
        if (additionalStyles.menu) {
            return {
                ...result,
                ...additionalStyles.menu,
            };
        }
        return result;
    },
    option: (provided, state) => {
        return {
            ...provided,
            backgroundColor: state.isSelected
                ? globalTheme.palette.primary[300]
                : state.isFocused
                    ? globalTheme.palette.primary[50]
                    : provided.backgroundColor,
            "&:active": {
                backgroundColor: state.isSelected
                    ? globalTheme.palette.primary[300]
                    : state.isFocused
                        ? globalTheme.palette.primary[50]
                        : provided.backgroundColor,
            },
        };
    },
    singleValue: (provided) => {
        return {
            ...provided,
            width: "100%",
        };
    },
});

const customTheme = (theme, globalTheme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary: globalTheme.palette.primary.main,
    },
});

const SelectV = (props) => {
    const _props = merge({
        loading: false,
        required: true,
        isClearable: true,
    }, props);
    const globalTheme = useTheme();
    const additional_props = {};
    if (_props.Option && !_props.components) {
        additional_props["components"] = { Option: _props.Option };
    }
    const additionalStyles = _props.styles ? _props.styles : {};
    if (_props.multiple) {
        additionalStyles["container"] = (provided) => ({ ...provided, maxHeight: "unset" });
    }
    if (_props.disabled) {
        additionalStyles["control"] = (provided) => ({ ...provided, backgroundColor: "transparent" });
    }
    const st = _props.formStyles || {};
    const style = {
        ...customsStyles(globalTheme, additionalStyles),
        ...st,
    };
    return (
        <Select
            placeholder={_props.placeholder || undefined}
            isMulti={_props.multiple}
            className={classnames("selectv", _props.className)}
            options={_props.options}
            styles={style}
            theme={(theme) => customTheme(theme, globalTheme)}
            onChange={_props.onChange || undefined}
            onInputChange={_props.onInput}
            onKeyDown={_props.onKeyDown}
            closeMenuOnSelect={!_props.multiple}
            value={_props.value || null}
            defaultInputValue={_props.inputValue || undefined}
            {...additional_props}
            formatOptionLabel={_props.formatOptionLabel}
            isLoading={_props.loading}
            isClearable={_props.isClearable}
            isDisabled={_props.disabled}
            inputValue={_props.inputValue}
            menuIsOpen={_props.menuIsOpen}
            components={_props.components}
            required={_props.required}
            noOptionsMessage={() => {
                return "Type to search";
            }}
            menuPortalTarget={_props.defaultMenuPortalTarget ? undefined : document.body}
        />
    );
};

SelectV.propTypes = {
    Option: PropTypes.any,
    className: PropTypes.any,
    components: PropTypes.any,
    disabled: PropTypes.bool,
    formatOptionLabel: PropTypes.any,
    inputValue: PropTypes.any,
    loading: PropTypes.bool,
    menuIsOpen: PropTypes.bool,
    multiple: PropTypes.bool,
    onChange: PropTypes.func,
    onInput: PropTypes.any,
    onKeyDown: PropTypes.any,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            label: PropTypes.string,
        })
    ),
    placeholder: PropTypes.string,
    styles: PropTypes.any,
    value: PropTypes.any,
};

export default SelectV;

